import { useEffect, useState } from "react";
import { Package, Truck, Handshake, Scale } from "lucide-react";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";

export default function MarketStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/stats/public").then((r) => setS(r.data)).catch(() => {}); }, []);
  const items = [
    { icon: Package, label: "Open loads", value: s?.open_loads, testId: "stat-open-loads" },
    { icon: Scale, label: "Tons available", value: s?.open_tonnage?.toLocaleString(), testId: "stat-open-tonnage" },
    { icon: Truck, label: "Active transporters", value: s?.active_transporters, testId: "stat-active-transporters" },
    { icon: Handshake, label: "Deals connected this week", value: s?.deals_this_week, testId: "stat-deals-week" },
  ];
  return (
    <section className="px-6 md:px-12 py-14 bg-white border-b border-slate-200" data-testid="market-stats">
      <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-amber-700">
        <span className="relative flex w-2 h-2"><span className="absolute inline-flex w-full h-full rounded-full bg-emerald-500 opacity-75 animate-ping" /><span className="relative w-2 h-2 rounded-full bg-emerald-500" /></span>
        {t("Live on Mi-Load")}
      </div>
      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map((i, idx) => (
          <div key={i.label} className="hf-card p-5 hf-rise" style={{ animationDelay: `${idx * 70}ms` }}>
            <i.icon className="w-5 h-5 text-amber-600" />
            <p className="font-display font-bold text-3xl sm:text-4xl mt-3" data-testid={i.testId}>{s ? i.value ?? 0 : "–"}</p>
            <p className="text-sm text-slate-600 mt-1">{t(i.label)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
